export const validateOptionSubOptionRefs = (_, value) => {
  if (!Array.isArray(value) || value.length === 0) {
    return Promise.resolve()
  }

  for (const [optionIndex, optionItem] of value.entries()) {
    const option = optionItem || {}
    const subOptions = Array.isArray(option.subOptions) ? option.subOptions : []
    const seenRefs = new Set()

    for (const subOption of subOptions) {
      const refValue = String(subOption?.ref || '').trim()
      if (!refValue) continue

      const normalizedRef = refValue.toLowerCase()
      if (seenRefs.has(normalizedRef)) {
        return Promise.reject(
          new Error(`Option ${optionIndex + 1}: sub-option Ref ID must be unique.`)
        )
      }
      seenRefs.add(normalizedRef)
    }
  }

  return Promise.resolve()
}
